import { useContext, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Spinner } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import { COIAdmin } from "./COIAdmin";
import { COIClient } from "./COIClient";
import { CoiPumpAdmin } from "./CoiPumpAdmin";
import { CoiPumpClient } from "./CoiPumpClient";

type Section = "coi" | "pump";

export const COIPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);
  const [section, setSection] = useState<Section>("coi");
  if (isLoading) return <Spinner />;

  return (
    <Box sx={{ mt: "-80px", minHeight: "100vh", bgcolor: "#F3F3F0" }}>
      <Box sx={{ bgcolor: "#fff", borderBottom: "1px solid #E7E7E3", px: "26px" }}>
        <Tabs
          value={section}
          onChange={(_, value: Section) => setSection(value)}
          sx={{
            minHeight: 44,
            "& .MuiTab-root": { minHeight: 44, fontSize: 12, fontWeight: 850 },
            "& .MuiTabs-indicator": { bgcolor: "#ED8B00", height: 3 },
          }}
        >
          <Tab value="coi" label="Customer Owned Inventory" />
          <Tab value="pump" label="Pump COI" />
        </Tabs>
      </Box>
      {section === "coi"
        ? idRole === 3
          ? <COIClient />
          : <COIAdmin />
        : idRole === 3
          ? <CoiPumpClient />
          : <CoiPumpAdmin />}
    </Box>
  );
};
